import * as VueCookie from 'vue-cookie'
import menuParams from '@/store/modules/menu-params'
import Vue from 'vue'
import { LANG } from '@/store/mutation-types'

const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  lang: state => state.i18n.lang,
  menus: state => state.user.menus,
  methods: state => state.user.methods,
  operator: state => state.user.operator?state.user.operator:VueCookie.get('operator'),
  fields: state => state.fields.fields,
  antLocale: state => state.i18n.antLocale,
  menuParams: state => state.menuParams.menuParams,
  formJson: state => state.app.formJson,
  hotKeys: state => state.permission.hotKeys
}

export default getters
